import Big from 'big.js';

import { Client } from 'app/model/Client';
import { StreetAddress } from 'app/model/StreetAddress';

export const DEFAULT_ORDER_STATE = 'CREATED';
export const DEFAULT_ORDER_SOURCE = (window as any).env
    .APPLICATION_CODE as string;

/**
 * Заявка на карту.
 */
export class CardOrder {
    /**
     * Уникальный идентификатор заявки
     */
    id: string;

    /**
     * Канал продаж
     */
    saleChannel: string;

    /**
     * Данные о клиенте банка
     */
    client: Client;

    /**
     * Имя Фамилия для печати на карточном продукте
     */
    cardholderName: string;

    /**
     * Код карточного продукта
     */
    cardProductCode: string;

    /**
     * Код выбранной группы условий в рамках продукта
     */
    cardProductId: string;

    /**
     * Код выбранного страхового продукта
     */
    insuranceProductCode: string;

    /**
     * Запрашиваемая сумма
     */
    amount: Big;

    /**
     * Трёхбуквенный код валюты запрашиваемой суммы
     */
    currency: string;

    /**
     * Адрес доставки
     */
    deliveryAddress: StreetAddress;

    /**
     * Момент времени аутентификации клиента.
     * Содержит значение, полученное от сервиса аутентификации, при успешном прохождении аутентификации.
     */
    authenticationTimestamp: string;

    /**
     * Условное обозначение выполняемого или выполненного этапа формирования заявки.
     */
    stage: string;

    /**
     * Состояние обработки заявки в PrintDoc
     */
    state: string;

    /**
     * Идентификатор системы-источника заявки.
     * Источник заявки - это система, в которой пользователь заполняет заявку.
     * Каждой системе назначается собственный идентификатор.
     */
    source: string;

    /**
     * Порядковый номер заявки в PrintDoc
     */
    number: string;

    constructor(
        id: string,
        saleChannel: string,
        client: Client,
        cardProductCode: string,
        cardProductId: string,
        insuranceProductCode: string,
        amount: Big,
        currency: string,
        deliveryAddress: StreetAddress,
        authenticationTimestamp: string,
        stage: string,
        cardholderName: string,
        state: string,
        number: string,
        source: string,
    ) {
        this.id = id;
        this.saleChannel = saleChannel;
        this.client = client;
        this.cardProductCode = cardProductCode;
        this.cardProductId = cardProductId;
        this.insuranceProductCode = insuranceProductCode;
        this.amount = amount;
        this.currency = currency;
        this.deliveryAddress = deliveryAddress;
        this.authenticationTimestamp = authenticationTimestamp;
        this.stage = stage;
        this.cardholderName = cardholderName;
        this.state = state;
        this.number = number;
        this.source = source;
    }

    static default(): CardOrder {
        return new CardOrder(
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            DEFAULT_ORDER_STATE,
            null,
            DEFAULT_ORDER_SOURCE,
        );
    }

    static create(
        cardProductCode: string,
        cardProductId: string,
        saleChannel: string,
        amount: Big,
        client: Client,
        insuranceCode: string,
    ): CardOrder {
        return new CardOrder(
            null,
            saleChannel,
            client,
            cardProductCode,
            cardProductId,
            insuranceCode,
            amount,
            'BYN',
            null,
            null,
            null,
            null,
            DEFAULT_ORDER_STATE,
            null,
            DEFAULT_ORDER_SOURCE,
        );
    }

    static deserialize(data: any) {
        return new CardOrder(
            data.id,
            data.saleChannel,
            Client.deserialize(data.client),
            data.cardProductCode,
            data.cardProductId,
            data.insuranceProductCode,
            data.amount !== null ? new Big(data.amount) : null,
            data.currency,
            StreetAddress.deserialize(data.deliveryAddress),
            data.authenticationTimestamp,
            data.stage,
            data.cardholderName,
            data.state,
            data.number,
            data.source,
        );
    }
}
